import React from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import { SiNvidia } from "react-icons/si";

const PricingModalPlaybox = ({ show, handleClose, selectedPlan, plans }) => {
    const { t } = useLanguage()

    return (
        <Modal show={show} onHide={handleClose} className="modal_pricing">
            <div className="modal_pre_body_pricing">
                <p className="modal_pre_body_pricing_title">How does pricing work?</p>
                <p className="modal_pre_body_pricing_subtitle">After reaching the maximum resource capacity, Erioon can automatically scale nodes, with additional costs applied in predefined blocks.</p>
                {/* <p className="modal_pre_body_pricing_alert">Go yearly and get one month free—every single year!</p> */}

            </div>
            <div className="modal_body_pricing">
                <p className="review_cont_data">Price <span>{plans[selectedPlan].price != null
                    ? (plans[selectedPlan].price < 0.09
                        ? `$${plans[selectedPlan].price}`
                        : `$${plans[selectedPlan].price.toFixed(2)}`
                    ) + "/hour"
                    : "Pricing unavailable"} </span></p>
                <p className="review_cont_data">vCPUs <span>{plans[selectedPlan].cpu}</span></p>
                    <p className="review_cont_data">RAM <span>{plans[selectedPlan].memory} GB</span></p>
                {plans[selectedPlan].gpu && (
                    <p className="review_cont_data">GPU <span> {plans[selectedPlan].gpu && (<span className="nvidia_logo"><SiNvidia /></span>)} {plans[selectedPlan].gpu}</span></p>
                )}
                {/* <p className="review_cont_data">Writes <span>{writes_price}</span></p> */}
            </div>
            <div className="modal_footer">
                <div className="footer_btn_cont">
                    <button className="cancel_btn" onClick={handleClose}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};

export default PricingModalPlaybox;
